import { DETAIL_PURCHASE_AIRALO, DETAIL_PURCHASE_AIRALO_ERROR } from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

// Action function
export const purchaseOrderDetailAiraloAction = (airalo_order_id) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(`/api/airalo-orders/${airalo_order_id}`);

    const { data, status } = response || {};

    dispatch({
      type: DETAIL_PURCHASE_AIRALO,
      response: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: DETAIL_PURCHASE_AIRALO_ERROR,
      response: e || {},
    });
  }
};
